import { matchVersion } from '../../utils';
import __regexp from './__edge-ios-regexp';
/** Detect Microsoft Edge iOS Browser version */
export default function isEdgeIOSVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
